"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var itemId_1 = require("owa-service/lib/factory/itemId");
/**
 * Get the ItemIds in the specified conversations
 * @param itemIdsToUpdate an array of item id strings
 * @return an array of ItemIds for EWS service request
 */
function getServiceItemIds(itemIdsToUpdate) {
    var itemIds = itemIdsToUpdate.map(function (id) { return itemId_1.default({ Id: id }); });
    return itemIds;
}
exports.default = getServiceItemIds;
//# sourceMappingURL=getServiceItemIds.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-store/lib/services/utils/getServiceItemIds.js
// module id = 3193
// module chunks = 62